import React from "react";
import EmailHeader from "./EmailHeader";
import CodeToolbar from "./CodeToolbar";
import EmailBuilderActions from "./actions/EmailBuilderActions";
import Cookies from 'js-cookie';

export default class CodeEditor extends React.Component{
  constructor(props) {
    super(props);
    this.state = {
      body: this.props.email && this.props.email.body ? this.props.email.body : '',
    }
    this.onChange = this.onChange.bind(this)
    this.focusInput = this.focusInput.bind(this)
    this.getCaret = this.getCaret.bind(this)
  }

  componentDidUpdate() {
    if (this.props.email.email_type == "campaign") {
      var help_type = "campaign"
    } else if (this.props.email.lifecycle_event == undefined || this.props.email.lifecycle_event == 'reservation_created' || this.props.email.lifecycle_event == 'reservation_start_date' || this.props.email.lifecycle_event == 'reservation_end_date') {
      var help_type = "reservation";
    } else {
      var help_type = "room";
    }

    Cookies.set('help_type', help_type)
    Cookies.set('help_type_name', this.props.email.lifecycle_event || this.props.email.email_type)
  }

	render() {
		return (
			<div className="editorWrapper">
				<EmailHeader {...this.props} {...this.state} />

				<CodeToolbar {...this.props} {...this.state} />

				<div className="code-editor">
					<div className="code-window">
						<h5>{I18n.t('code')}</h5>
						<textarea id="email-builder-code-editor-textarea" ref="body" value={this.state.body} name="email[body]" data-name="body" onFocus={this.focusInput} onKeyDown={this.getCaret} onKeyPress={this.getCaret} onMouseMove={this.getCaret} onChange={this.onChange} spellCheck={false} autoComplete="off" autoCorrect="off" autoCapitalize="off"></textarea>
					</div>

					<div className="preview-window">
						<h5>{I18n.t('preview')}</h5>
						<div className="preview-wrapper" dangerouslySetInnerHTML={{__html: this.state.body}}></div>
					</div>
				</div>
			</div>
		);
	}

	onChange(e) {
		var self = this;

		this.setState({body: e.target.value}, function () {
			if (typeof self.props.onChange == 'function') {
				self.props.onChange(self.state.body);
			}
		});
	}

  focusInput(event) {
    EmailBuilderActions.focusInput($(event.target).data('name'));
  }

  getCaret(event) {
    var name = $(event.target).data('name');

    if (typeof name == 'undefined' || name != this.props.focusedInput) {
      return;
    }

    var caretPos = $(this.refs[name]).caret();
    EmailBuilderActions.setCaretPosition(caretPos);
  }
};
